import React from 'react'
import PropTypes from 'prop-types'
import { Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

class SettlementPaymentEmailDialogBoundary extends React.Component {
  state = { failed: false }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  componentDidCatch(error) {
    console.error('Settlement email dialog could not render.', error)
  }

  render() {
    if (!this.state.failed) return this.props.children

    return <Modal isOpen backdrop='static'>
      <ModalHeader>Dialog email belum dapat ditampilkan</ModalHeader>
      <ModalBody><Alert color='warning' role='alert'>Tutup dialog lalu refresh detail settlement. Periksa status email terbaru sebelum mencoba lagi; pengiriman tidak diulang otomatis.</Alert></ModalBody>
      <ModalFooter><Button type='button' disabled={ this.props.busy } onClick={ this.props.onClose }>Tutup</Button></ModalFooter>
    </Modal>
  }
}

SettlementPaymentEmailDialogBoundary.propTypes = { children: PropTypes.node.isRequired, busy: PropTypes.bool, onClose: PropTypes.func.isRequired }
export default SettlementPaymentEmailDialogBoundary
